import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CheckInRequest } from '../models/attendance/checkin-request.model';
import { CheckOutRequest } from '../models/attendance/checkout-request.model';
import { MonthlyReportRow } from '../models/attendance/monthly-report.model';
import { environment } from 'src/environments/environment';
import { IsValidLocation } from '../models/attendance/validlocation.model';

@Injectable({
  providedIn: 'root'
})
export class AttendanceService {

  private baseUrl = `${environment.baseUrl}`;

  constructor(private http: HttpClient) { }

  // ==============================
  // 📍 Get GPS Location Helper
  // ==============================
  getCurrentLocation(): Promise<any> {
    return new Promise((resolve, reject) => {

      if (!navigator.geolocation) {
        reject('Geolocation not supported');
        return;
      }

      navigator.geolocation.getCurrentPosition(
        position => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            accuracy: position.coords.accuracy
          });
        },
        error => reject(error),
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    });
  }

  isValidOfficeLocation(currentlatitude: number, currentlongitude: number, officelatitude: number, officelongitude: number): Observable<boolean> {
       return this.http.get<boolean>(`${this.baseUrl}Attendance/IsValidOfficeLocation?currentlatitude=${currentlatitude}&currentlongitude=${currentlongitude}&officelatitude=${officelatitude}&officelongitude=${officelongitude} ` );
  }


  // ==============================
  // 🟢 CHECK-IN API
  // ==============================
  checkIn(request: CheckInRequest): Observable<any> {
    return this.http.post(`${this.baseUrl}Attendance/checkin`, request);
  }

  // ==============================
  // 🔴 CHECK-OUT API
  // ==============================
  checkOut(request: CheckOutRequest): Observable<any> {
    return this.http.post(`${this.baseUrl}Attendance/checkout`, request);
  }

  // ==============================
  // 📊 GET IP ADDRESS
  // ==============================
  
  getIPAddress() {
    return this.http.get<any>('https://api.ipify.org?format=json');
  }


  // ==============================
  // 📊 MONTHLY REPORT API
  // ==============================
  getMonthlyReport(userId: number, month: number, year: number)
    : Observable<MonthlyReportRow[]> {

    return this.http.get<MonthlyReportRow[]>(
      `${this.baseUrl}Attendance/monthly-report?userId=${userId}&month=${month}&year=${year}`
    );
  }
}